//
//  SDKFigmaComponentPreviewContainerSize.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//  Copyright © 2021 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var FigmaComponentPreviewContainerSize;
(function (FigmaComponentPreviewContainerSize) {
    FigmaComponentPreviewContainerSize["centered"] = "Centered";
    FigmaComponentPreviewContainerSize["naturalHeight"] = "NaturalHeight";
})(FigmaComponentPreviewContainerSize || (FigmaComponentPreviewContainerSize = {}));
